var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"color":_vm.buttonColor,"icon":"","depressed":""},on:{"click":_vm.handleClick}},[_c('v-icon',[_vm._v("mdi-crosshairs-gps")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }